export enum TrackingMatrix {
	pageView = "1",
	scrollDepth = "4",
	buttonClick = "5",
	orientationChange = "6",
	tabChange = "50",
	errorPageView = "23",
	downloadOnlineManual = "39",
	search = "55",
	searchResults = "56",
	searchError = "58",
	focus = "57"
}

export type ExternalTrackingData = { [key: string]: string };

export class TrackingActions {
	public static ActionOrientationChange: string = "Orientation change";
	public static ActionTabChage: string = "[Module name] - [Module headline]";
	public static ActionDownloadOnlineManual: string = "Download online manual";
	public static ActionModelSearch = "Model Search";
	public static ActionVinSearch = "VIN Search";
	public static ActionSearchResults = "SearchResults";
	public static ScrollDown = "Scroll down";
}

export enum TrackingType {
	pageView = "Pageview",
	trackEvent = "Event",
}

export interface ICommonTrackingData {
	event: "pageView" | "trackEvent";
	eventCategory?: "All pages" | "Button click" | "Tab change" | "Owner's manual";
	eventAction?: string;
	eventLabel?: string;
	eventNonInteraction?: "true" | "false";
	documentPath?: AppDocumentPath;
	"ga.ClientId"?: string;
	"appweb.Name"?: AppWebName;
	"importer.BID"?: string;
	"page.Group"?: PageGroup;
	"page.Name"?: string;
	"page.LanguageVersion"?: string;
	"page.Context"?: PageContext;
	"page.ResponsiveLayout"?: "Desktop" | "Tablet" | "Mobile";
	"page.Orientation"?: "Landscape" | "Portrait"
	"page.ScrollDepth"?: string;
	"car.Model"?: string;
	"car.OmsId"?: string;
	"hit.ClickURL"?: string;
	"web.environment": string;
	matrixId: TrackingMatrix;
}

export type ITrackingObject = ICommonTrackingData

export type AppWebName = "page_view" | "scroll_down" | "button_click" | "orientation_change" | "tab_change" | "manual_open" | "manual_search" | "manual_searchresults" | "manual_errortype" | "manual_focus";
export type AppDocumentPath = "/Models" | "/Detail" | "/page-not-found";
export type PageGroup = "Owner's manual NG";
export type PageContext = "Importer";
